<template>
    <div :class="{'col-xl-12': mode == 'table', 'col-xl-6': mode == 'graph'}">
        <b-overlay
            :show="status === 'loading'"
        >
            <b-card
                no-body
            >
                <div class="card-header align-items-start">
                    <div class="card-group-title">
                        <b-card-title>
                            {{ $t('org.billing.Product Cost') }}
                        </b-card-title>
                    </div>
                    <b-card-actions-container
                        v-if="(lastMonthProducts && lastMonthProducts.length) || (thisMonthProducts && thisMonthProducts.length)"
                        class="card-actions-container"
                        @card:collapse="toggleMode"
                    />
                </div>
                <b-card-body>
                    <template v-if="(lastMonthProducts && lastMonthProducts.length) || (thisMonthProducts && thisMonthProducts.length)">
                        <ProductCardChart
                            ref="container"
                            :svg="svg"
                            :mode="mode"
                            :data="data"
                            @resize:svg="handleResize"
                            @detail-layer="detailLayer"
                        >
                        </ProductCardChart>
                        <ProductCardTable
                            v-show="mode === 'table'"
                            :lastMonthProducts="lastMonthProducts"
                            :thisMonthProducts="thisMonthProducts"
                            @detail-layer="detailLayer"
                        ></ProductCardTable>
                    </template>
                    <template v-else>
                        <div class="d-flex justify-content-center align-items-center flex-column text-center">
                            <SVGEmptyIcon/>
                            <span>{{ $t('org.dashboard.No data') }}</span>
                        </div>
                    </template>
                </b-card-body>
            </b-card>
        </b-overlay>
    </div>
</template>

<script>
import BCardActionsContainer from '@/components/BCardActionsContainer'
import ProductCardChart from './ProductCardChart'
import ProductCardTable from './ProductCardTable'
import useCommonData from '@/composables/useCommonData'
import { computed, ref, getCurrentInstance, watch, toRefs } from '@vue/composition-api'
import SVGEmptyIcon from '@/assets/images/empty.svg'
export default {
    components: {
        BCardActionsContainer,
        ProductCardChart,
        ProductCardTable,
        SVGEmptyIcon
    },
    props: {
        expanded: {
            type: String,
            default: null
        },
        data: {
            type: Object,
            default: function () {
                return {
                    lastMonthProducts: [],
                    thisMonthProducts: []
                }
            }
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const { expanded } = toRefs(props)
        const store = vm.$store
        const status = computed(() => store.getters['$_summary/status'])
        const svg = ref({ width: 0, height: 200, paddingT: 0 })
        const mode = ref('graph')
        const { __toKFormat } = useCommonData()
        const thisMonthProducts = computed(() => props.data.thisMonthProducts || [])
        const lastMonthProducts = computed(() => props.data.lastMonthProducts || [])
        const detailLayer = (productCode) => {
            if (productCode.toLowerCase() !== 'etc') {
                context.emit('detail-layer', { productCode })
            }
        }
        const container = ref(null)
        const handleResize = () => {
            if (container.value) {
                svg.value.width = container.value.$el.clientWidth
                svg.value.height = Math.min(svg.value.width * 0.75, (mode.value === 'graph' ? 250 : 300))
            }
        }
        const emitExpanded = () => context.emit('expand-panel', mode.value === 'table' ? 'product' : null)
        const toggleMode = () => {
            mode.value = mode.value === 'graph' ? 'table' : 'graph'
            vm.$nextTick(() => {
                handleResize()
            })
            emitExpanded()
        }
        watch(expanded, (value) => {
            mode.value = value === 'product' ? 'table' : 'graph'
            vm.$nextTick(() => {
                handleResize()
            })
        })
        return {
            status,
            svg,
            mode,
            container,
            thisMonthProducts,
            lastMonthProducts,
            __toKFormat,
            detailLayer,
            toggleMode,
            handleResize
        }
    }
}
</script>

<style>
#containerProductCard text.shadow {
    text-shadow: #000 2px 2px 10px
}
#containerProductCard .list-enter-active, #containerProductCard .list-leave-active {
    transition: all 1s;
}
#containerProductCard .list-enter, #containerProductCard .list-leave-to  {
    opacity: 0;
    transform: translateY(-30px);
}
</style>
